import { render } from "./FlagsComponent.vue?vue&type=template&id=78b4e4ee"
import script from "./FlagsComponent.vue?vue&type=script&lang=js"
export * from "./FlagsComponent.vue?vue&type=script&lang=js"

import "./FlagsComponent.vue?vue&type=style&index=0&id=78b4e4ee&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__